import * as api from '../../api/events';
import { asyncAction } from '../common';
import { eventsFilterActions } from '../../constants/filter';

export const changeEventChartMode = (single) => ({
  type: 'EVENT_EXECUTE_SET_CHART_MODE',
  single,
});

export const setEventColumnChartSorting = (sorting) => ({
  type: 'CHANGE_EVENT_COLUMN_CHART_SORTING',
  sorting,
});

export const addEvent = () => ({
  type: 'EVENTS_COMPOSE_ADD_EVENT',
});

export const duplicateEvent = (id) => ({
  type: 'EVENTS_COMPOSE_DUPLICATE_EVENT',
  id,
});

export const removeComposeEvent = (id) => ({
  type: 'EVENTS_COMPOSE_REMOVE_EVENT',
  id,
});

export const setName = (id, name, eventMetainf) => ({
  type: 'EVENTS_COMPOSE_SET_EVENT_NAME',
  id,
  name,
  eventMetainf,
});

export const setGroupColumn = (groupColumn) => ({
  type: 'EVENTS_COMPOSE_SET_GROUP_COLUMN',
  groupColumn,
});

export const setAggregationType = (id, aggregationType) => ({
  type: 'EVENTS_COMPOSE_SET_EVENT_AGGREGATION_TYPE',
  id,
  aggregationType,
});

export const setEventAggregationColumn = (id, aggregationColumn) => ({
  type: 'EVENTS_COMPOSE_SET_EVENT_AGGREGATION_COLUMN',
  id,
  aggregationColumn,
});

export const setSplitColumn = (id, splitColumn) => ({
  type: 'EVENTS_COMPOSE_SET_EVENT_SPLIT_COLUMN',
  id,
  splitColumn,
});

export const addFilterClause = (eventId) => ({
  type: eventsFilterActions.ADD_FILTER_CLAUSE,
  eventId,
});

export const removeFilterClause = (eventId, clauseId) => ({
  type: eventsFilterActions.REMOVE_FILTER_CLAUSE,
  eventId,
  id: clauseId,
});

export const setClausesConcatOperator = (eventId, value) => ({
  type: eventsFilterActions.SET_CLAUSES_CONCAT_OPERATOR,
  eventId,
  value,
});

export const setFilterClauseField = (eventId, clauseId, field, fieldType) => ({
  type: eventsFilterActions.SET_FILTER_CLAUSE_FIELD,
  eventId,
  id: clauseId,
  field,
  fieldType,
});

export const setFilterClauseValue = (eventId, clauseId, value) => ({
  type: eventsFilterActions.SET_FILTER_CLAUSE_VALUE,
  eventId,
  id: clauseId,
  value,
});

export const setFilterVisibility = (eventId, value) => ({
  type: eventsFilterActions.SET_FILTER_VISIBILITY,
  eventId,
  value,
});

export const removeFilter = (eventId) => ({
  type: eventsFilterActions.REMOVE_FILTER,
  eventId,
});

export const copyFilter = (eventId, clauses) => ({
  type: eventsFilterActions.COPY_FILTER,
  eventId,
  clauses,
});

export const setFilterClauseOperator = (eventId, clauseId, value, resetClauseValue) => ({
  type: eventsFilterActions.SET_FILTER_CLAUSE_OPERATOR,
  eventId,
  id: clauseId,
  value,
  resetClauseValue,
});

export const setOthersFilter = (eventId, clauseId) => ({
  type: 'SET_OTHERS_FILTER',
  eventId,
  clauseId,
});

export const toggleCalcTotal = () => ({
  type: 'TOGGLE_EVENTS_CALC_TOTAL',
});

export const toggleTrendLine = () => ({
  type: 'TOGGLE_EVENTS_TREND_LINE',
});

export const toggleAverageLine = () => ({
  type: 'TOGGLE_EVENTS_AVERAGE_LINE',
});

export const toggleMedianLine = () => ({
  type: 'TOGGLE_EVENTS_MEDIAN_LINE',
});

export const toggleAdaptive = () => ({
  type: 'TOGGLE_EVENTS_ADAPTIVE',
});

export const toggleCumulative = () => ({
  type: 'TOGGLE_EVENTS_CUMULATIVE',
});

export const changeVisibleFormula = () => ({
  type: 'EVENT_CHANGE_VISIBLE_FORMULA',
});

export const enterFormula = (formula) => ({
  type: 'EVENT_ENTER_FORMULA',
  enteredFormula: formula,
});

export const setEventExposeError = (error, id) => ({
  type: 'SET_EVENT_EXPOSURE_ERROR',
  error,
  id,
});

export const addPeriod = (id) => ({
  type: 'ADD_PERIOD',
  eventId: id,
});

export const deletePeriod = (id, index) => ({
  type: 'DELETE_PERIOD',
  eventId: id,
  index,
});

export const setPeriod = (id, index, from, to) => ({
  type: 'SET_PERIOD',
  eventId: id,
  index,
  from,
  to,
});

export const copyPeriods = (id, periods) => ({
  type: 'COPY_PERIODS',
  eventId: id,
  periods,
});

export const setShowPeriods = (id, value) => ({
  type: 'SET_SHOW_PERIODS',
  eventId: id,
  value,
});

export const setEventExecuteId = (executeId) => ({
  type: 'SET_EVENT_EXECUTE_ID',
  executeId,
});

export const executeEventQueries = (executeId) =>
  asyncAction('EXECUTE_EVENT_QUERIES', api.executeEventQueries(executeId));

const exposeEventErrorHandler = (id) => (dispatch, getState, errorText) =>
  dispatch(setEventExposeError(errorText, id));

export const exposeEventQuery = (id, clauseId) =>
  asyncAction(
    'EXPOSE_EVENT_QUERY',
    api.exposeEventQuery(id, clauseId),
    exposeEventErrorHandler(id)
  );

export const fetchMetainf = () => asyncAction('FETCH_METAINF', api.fetchMetainf());

export const changeEventView = (view) => ({
  type: 'CHANGE_EVENT_VIEW',
  view,
});
